import debounce from "lodash/debounce";
import {
	totalmem
} from "os";

export default {
	data() {
		return {
			cart: [],
			cartLoading: true,
			disableField: true,
			paymentError: '',
			latestCartDefaultBoxQty: 0,
			latestCartDefaultPlasticBagQty: 0,
			latestCartDefaultDiningUtensilQty: 0,
		};
	},
	mounted() { },
	created: async function () {
		await this.checkError();
		await this.getCart();
		$('.loadingHide').removeClass('loadingHide');
		$('.list_toggle').on('click', function () {
			if ($(this).hasClass('collapse_list')) {
				$(this).addClass('expand_list');
				$(this).removeClass('collapse_list');
				$('div#' + this.id).show();
			} else {
				$(this).addClass('collapse_list');
				$(this).removeClass('expand_list');
				$('div#' + this.id).hide();
			}
		});
		if (this.paymentError){
			if(typeof window[this.paymentError] != undefined){
				await this.showErrorModal(window[this.paymentError]);
			} else {
				await this.showErrorModal();
			}
		}

		// push GTM data layer
		const currentPageEventElement = document.getElementById('currentPageEvent');
		if (currentPageEventElement) {
			// Element exists, access its value
			const currentPageEventValue = currentPageEventElement.value;
			if (currentPageEventValue == 'add_shipping_info') {
				window.dataLayer = window.dataLayer || [];
				const itemsArray = [];
				Object.keys(this.cart).forEach((key) => {
					itemsArray.push({
						item_id: this.cart[key]?.detail?.pos_code,
						item_name: this.cart[key]?.detail?.name_en,
						price: this.cart[key]?.total,
						quantity: this.cart[key]?.qty
					});
				});
				dataLayer.push({
					event: "add_shipping_info",
					currency: "HKD",
					value: parseFloat(document.getElementById('total-amount').value),
					shipping_tier: document.getElementById('delivery-type').value,
					items: itemsArray
				});
			} else if (currentPageEventValue == 'purchase') {
				window.dataLayer = window.dataLayer || [];
				const cartArray = document.getElementById('shoppingCart').value ? JSON.parse(document.getElementById('shoppingCart').value) : null;
				const itemsArray = [];
				Object.keys(cartArray).forEach((key) => {
					itemsArray.push({
						item_id: cartArray[key]?.detail?.pos_code,
						item_name: cartArray[key]?.detail?.name_en,
						price: cartArray[key]?.total,
						quantity: cartArray[key]?.qty
					});
				});
				dataLayer.push({
					event: "purchase",
					currency: "HKD",
					value: parseFloat(document.getElementById('orderAmount').value),
					transaction_id: document.getElementById('orderNumber').value,
					items: itemsArray
				});
			}
		}
	},
	watch: {
		cart: {
			handler(newValue, oldValue) {
				const reg = /^[0-9]+$/;
				Object.keys(newValue).forEach(key => {
					let qty = String(newValue[key]['qty'])
					if ((!qty || qty.match(reg) === null) && this.cart[key] && oldValue[key]) {
						this.cart[key]['qty'] = oldValue[key]['qty']
					}
				})
			},
			immediate: true,
			deep: true
		}
	},
	computed: {
		lang() {
			return document.getElementsByTagName("html")[0].getAttribute("lang");
		},
		category() {
			const category = document.querySelector('[name=category]');
			return category ? category.value : '';
		},
		cartCategory() {
			if (!this.cart) return null;
			let items = Object.values(this.cart);
			let categoryId = null;
			items.forEach(function (item, index) {
				if (item.category_id && !item.gift_discount_id) {
					categoryId = parseInt(item.category_id);
				}
			});
			return categoryId;
		},
		cartCount() {
			if (!this.cart || this.cart.length == 0) {
				return 0;
			}

			if (typeof this.cart.message !== 'undefined') {
				return 0;
			}

			let items = Object.values(this.cart);

			var mode = null;
			if (items[0].hasOwnProperty('vue')) {
				mode = 'monp';
			}

			// check format
			if (mode) {
				items = items ? items.filter(el => !el.free_gift_discount_id && !el.is_extra_takeaway) : [];
				return items.length ? items.map(el => el.vue.quantity).reduce((a, b) => a + b) : 0;
			}

			// festive
			items = items ? items.filter(el => !el.gift_discount_id && !el.is_extra_takeaway) : [];
			return items.length ? items.map(el => el.qty).reduce((a, b) => a + b) : 0;
		},
		productCount() {
			let count = {}
			Object.keys(this.cart).forEach(key => {
				if (!this.cart[key].gift_discount_id) {
					count[this.cart[key].id] = this.cart[key].qty
				}
			})
			return count
		}
	},
	methods: {
		async api(url, method, data = null, errorCallback = null) {
			let config = {
				method: method,
				url: url,
				timeout: 30000
			}
			if (data) config.data = data
			let result;
			this.cartLoading = true
			try {
				result = await axios(config);
			} catch (e) {
				result = e.response;
			} finally {
				this.cartLoading = false
				return (({
					data,
					status
				}) => ({
					data,
					status
				}))(result)
			}
		},
		init() { },
		async getCart() {
			const result = await this.api('/ordering/cart', 'get');
			this.cartCallback(result);
			this.setTimeOutGetCart();
		},
		async getLatestTakeawayDefaultQty() {
			const result = await this.api('/ordering/checkout/getLatestTakeawayDefaultQty', 'get');
			if (result.data) {
				if (result.data.takeawayBox)
					this.latestCartDefaultBoxQty = result.data.takeawayBox.defaultQty;
				if (result.data.takeawayPlasticBag)
					this.latestCartDefaultPlasticBagQty = result.data.takeawayPlasticBag.defaultQty;
				if (result.data.takeawayDiningUtensil)
					this.latestCartDefaultDiningUtensilQty = result.data.takeawayDiningUtensil.defaultQty;
			}
		},
		async addCart(productId, qty) {
			const result = await this.api('/ordering/cart', 'post', {
				productId,
				qty,
				category: this.category
			})
			this.cartCallback(result);
			for (let key in this.cart) {
				this.$set(this.cart[key], "edit", false);
				// push GTM data layer
				if (this.cart[key]?.id == productId) {
					window.dataLayer = window.dataLayer || [];
					dataLayer.push({
						event: "add_to_cart",
						currency: "HKD",
						value: this.cart[key]?.total * qty,
						item: [
						{
							item_id: this.cart[key]?.detail.pos_code,
							item_name: this.cart[key]?.detail.name_en,
							price: this.cart[key]?.total,
							quantity: qty
						}
						]
					});
				}
			}
		},
		async updateCart(productId, evt, qty = null) {
			let raw_id = '';
			let orignal_qty = 0;
			for (let item in this.cart) {
				if (this.cart[item].id === productId) {
					raw_id = this.cart[item].raw_id;
					orignal_qty = this.cart[item].qty;
					break;
				}
			}
			const result = await this.api(`/ordering/cart/${raw_id}`, 'put', {
				qty: qty || parseInt(evt.target.value)
			})
			await this.getLatestTakeawayDefaultQty();
			this.cartCallback(result);
			// push GTM data layer
			if (qty && this.cart[raw_id]?.id == productId && ((qty || parseInt(evt.target.value)) - orignal_qty) > 0) {
				window.dataLayer = window.dataLayer || [];
				dataLayer.push({
					event: "add_to_cart",
					currency: "HKD",
					value: this.cart[raw_id]?.total * ((qty || parseInt(evt.target.value)) - orignal_qty),
					item: [
					{
						item_id: this.cart[raw_id]?.detail.pos_code,
						item_name: this.cart[raw_id]?.detail.name_en,
						price: this.cart[raw_id]?.total,
						quantity: ((qty || parseInt(evt.target.value)) - orignal_qty)
					}
					]
				});
			}
		},
		async removeCart(raw_id) {
			const result = await this.api(`/ordering/cart/${raw_id}`, 'delete', null, this.cartError);
			await this.getLatestTakeawayDefaultQty();
			this.cartCallback(result);
		},
		async cleanCart() {
			const result = await this.api(`/ordering/cart/clean`, 'get', null, this.cartError);
			this.cartCallback(result);
		},
		setTimeOutGetCart() {
			var timeoutWithMinute = 15;
			var self = this;

			setTimeout(function () {
				self.getCart();
			}, timeoutWithMinute * 60 * 1000);
		},
		getTotalAmount() {
			const price = {
				cartRetailTotal: 0,
				cartOrigTotal: 0,
				cartTotal: 0
			}
			for (let item in this.cart) {
				if (!this.cart[item].is_extra_takeaway) {
					const {
						retail_total,
						orig_total,
						total
					} = this.cart[item];
					price.cartRetailTotal += retail_total;
					price.cartOrigTotal += orig_total;
					price.cartTotal += total;
				}
			}
			return price;
		},
		async changeLang(lang) {
			try {
				if (lang !== this.lang) {
					this.cartLoading = true;
					await this.api(`/ordering/lang/${lang}`, 'get');
					this.cartLoading = false;
					location.reload();
				}
			} catch (e) {
				this.cartLoading = false;
				alert(e)
			}
		},
		openNav() {
			document.getElementById("getmenu").style.width = "100%", document.body.style.overflow = "hidden"
		},
		closeNav() {
			document.getElementById("getmenu").style.width = "0%", document.body.style.overflow = "auto"
		},
		openSearch() {
			document.getElementById("getsearch").style.width = "100%", document.body.style.overflow = "hidden", document.getElementById("getsearch").className += " active"
		},
		closeSearch() {
			document.getElementById("getsearch").style.width = "0%", document.body.style.overflow = "auto", $("#getsearch").removeClass("active")
		},
		showErrorModal(message = null) {
			if (message) {
				$('#modal-content').html(message);
			}
			$('#errorModal').modal('show')
		},
		hideErrorModal() {
			$('#modal-content').html('');
			$('#errorModal').modal('hide')
		},
		cartCallback(result) {
			if (result.status == 200) {
				this.cart = result.data ? result.data : [];
			} else if (result.status === 419) {
				var errorMessage = {
					'tc': '由於閒置超過一段時間，購物籃已清空，請重新選擇物品',
					'en': 'Due to idle over long period, your shopping cart has been cleared.',
				};
				this.showErrorModal(errorMessage[this.lang])
				$('#errorModal').on('hide.bs.modal', function () {
					window.location.reload();
				});
			} else if (result.status === 500) {
				var errorMessage = {
					'en': 'Connection error, please try reload the page.',
					'tc': '連線發生問題，請重新加載。',
				};
				this.showErrorModal(errorMessage[this.lang]);
				$('#errorModal').on('hide.bs.modal', function () {
					window.location.reload();
				});
			} else {
				this.showErrorModal(result.data.message)
				if (result.status === 403) {
					$('#errorModal').on('hide.bs.modal', function () {
						window.location.reload()
					})
				}
				this.cart = result.data.cart ? result.data.cart : this.cart
			}
			this.$nextTick(function () {
				$('.loadingHide').removeClass('loadingHide');
			})
		},
		numberOnly(evt) {
			const reg = /^[0-9]$/;
			if (evt.key.match(reg) === null) {
				evt.preventDefault()
			}
		},
		checkError() {
			let error = qs.parse(window.location.search.replace("?", "")).error
			this.paymentError = error ? error : null;
			if (this.paymentError) {
				this.paymentError = this.paymentError
					.replace(/\&/g, "&amp;")
					.replace(/\</g, "&lt;")
					.replace(/\>/g, "&gt;")
					.replace(/\"/g, "&quot;")
					.replace(/\'/g, "&#x27")
					.replace(/\//g, "&#x2F");
			}
		},
		decimalPlace(val, decimalPlace) {
			return (Math.round(val * 100) / 100).toFixed(decimalPlace);
		},
		connectionErrorHanding(status) {
			var errorMessage = {
				'en': 'Connection error, please try reload the page.',
				'tc': '連線發生問題，請重新加載。',
			};
			this.errorHandling(status, errorMessage[this.lang]);
		},
		errorHandling(status, message) {
			this.showErrorModal(message || '');
			if (status === 403) {
				$('#errorModal').on('hide.bs.modal', function () {
					window.location.reload()
				})
			} else if (status === 419) {
				var errorMessage = {
					'tc': '由於閒置超過一段時間，購物籃已清空，請重新選擇物品',
					'en': 'Due to idle over long period, your shopping cart has been cleared.',
				};
				this.showErrorModal(errorMessage[this.lang])
				$('#errorModal').on('hide.bs.modal', function () {
					window.location.reload();
				});
			}
		}
	},
	destroyed() { }
};